import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";
import { Input, Table } from "reactstrap";
import Pagination from "react-js-pagination";
import Footer from "../../../GlobalComponents/Footer";
import Navbar from "../Navbar";
import moment from "moment";
import { repsBookingService } from "../../../../services/repsBooking.services";

import DatePicker from "react-datepicker";
// import * as excelJs from "exceljs";
import dateFormat from "dateformat";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { debounce } from "lodash";
import { history } from "../../../../helpers";
// import { Redirect } from "react-router-dom/cjs/react-router-dom.min";


// let newDate = new Date();
// let date = newDate.getDate();
// let month = newDate.getMonth() + 1;
// let year = newDate.getFullYear();
// let separator = "-";
// const todayDate = `${year}${separator}${month < 10 ? `0${month}` : `${month}`
//     }${separator}${date < 10 ? `0${date}` : `${date}`}`;

const initialFromDate = moment().subtract(6, "months").format("YYYY-MM-DD");
const initialToDate = moment().subtract(1, "days").format("YYYY-MM-DD");

const RepsDashboard = () => {
    // const [dataXlsx, setDataXlsx] = useState([]);
    const autoCorrectedDatePipe = createAutoCorrectedDatePipe("dd/MM/yyyy");
    const [search, setSearch] = useState("");
    const [filterOperationToDate, setfilterOperationToDate] = useState(initialToDate);
    const [filterOperationFromDate, setfilterOperationFromDate] = useState(initialFromDate);
    const [activePage, setActivePage] = useState(1); 
    const [totalItemsCount, setTotalItemsCount] = useState("");
    const [limit, setLimit] = useState(50);
    const [loading, setLoading] = useState(false);
    const [dayActive, setDateActive] = useState("past");
    const [bookingList, setBookingList] = useState([]);

    // const [searchOperationToDate, setSearchOperationToDate] = useState(newDate);
    // const [searchOperationFromDate, setSearchOperationFromDate] = useState(newDate);
    const [searchOperationToDate, setSearchOperationToDate] = useState(new Date(initialToDate));
    const [searchOperationFromDate, setSearchOperationFromDate] = useState(new Date(initialFromDate));
    const [listRefresh,setListRefresh] = useState(false);
    const [user,setUser] = useState(JSON.parse(localStorage.getItem("user")));

    const handleSearch = (val) => {
        setSearch(val);
        setActivePage(1);
        debouncedSearch(val);
    };

    const handlePageChange = (pageNumber) => {
        setActivePage(pageNumber);
        if(pageNumber !== activePage){
            setLoading(true);
            window.scrollTo({top: 0});
        }
        // getList();
    };

    const handlePageStates = (activePage, totalItemsCount, limit) => {
        if (totalItemsCount === undefined) {
            totalItemsCount = 0;
        }
        setActivePage(activePage);
        setTotalItemsCount(totalItemsCount);
        setLimit(limit);
    };

    // Using As Operations Today
    const toDay = () => {
        let newDate = new Date();
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        let separator = "-";
        const todayDate = `${year}${separator}${month < 10 ? `0${month}` : `${month}`
            }${separator}${date < 10 ? `0${date}` : `${date}`}`;
        setfilterOperationToDate(todayDate);
        setfilterOperationFromDate(todayDate);

        setSearchOperationToDate(newDate);
        setSearchOperationFromDate(newDate);

        setActivePage(1);
        setDateActive("today");
        //getList(todayDate,todayDate);
    };

    const setsGoingOutToday = () => {
        let newDate = new Date();
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        let separator = "-";
        const todayDate = `${year}${separator}${month < 10 ? `0${month}` : `${month}`
            }${separator}${date < 10 ? `0${date}` : `${date}`}`;
        setfilterOperationToDate(todayDate);
        setfilterOperationFromDate(todayDate);

        setSearchOperationToDate(newDate);
        setSearchOperationFromDate(newDate);

        setActivePage(1);
        setDateActive("setsGoingOutToday");
        //getList(todayDate,todayDate);
    };


    const nextDays = () => {
        let newDate = new Date();
        let date = newDate.getDate() + 1;
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        let separator = "-";
        const tomorrowDate = `${year}${separator}${month < 10 ? `0${month}` : `${month}`
            }${separator}${date < 10 ? `0${date}` : `${date}`}`;

        const searchTomorrowDate = new Date(tomorrowDate);

        setfilterOperationToDate(tomorrowDate);
        setfilterOperationFromDate(tomorrowDate);

        setSearchOperationToDate(searchTomorrowDate);
        setSearchOperationFromDate(searchTomorrowDate);

        //getList(tomorrowDate,tomorrowDate);
        setActivePage(1);
        setDateActive("tomorrow");
    };
    
    // Using as All Booking 
    const pastBookings = () => {
        var pastYearDate = moment().subtract(6, "months").format("YYYY-MM-DD");
        var yesterdayDate = moment().subtract(1, "days").format("YYYY-MM-DD");

        const searchFromDate = new Date(pastYearDate);
        const searchToDate = new Date(yesterdayDate);

        setfilterOperationToDate(yesterdayDate);
        setfilterOperationFromDate(pastYearDate);

        setSearchOperationToDate(searchToDate);
        setSearchOperationFromDate(searchFromDate);

        setActivePage(1);
        setDateActive("past");
        //getList(pastYearDate,yesterdayDate);
    };

    const missingPOs = () => {
        var pastYearDate = moment().subtract(6, "months").format("YYYY-MM-DD");
        var yesterdayDate = moment().subtract(1, "days").format("YYYY-MM-DD");

        const searchFromDate = new Date(pastYearDate);
        const searchToDate = new Date(yesterdayDate);

        setfilterOperationToDate(yesterdayDate);
        setfilterOperationFromDate(pastYearDate);

        setSearchOperationToDate(searchToDate);
        setSearchOperationFromDate(searchFromDate);

        setActivePage(1);
        // setDateActive("past");

         setDateActive("missingPOs");

        //getList(pastYearDate,yesterdayDate);
    };



    const getList = async (operationDate,toOperationDate,searchTerm,currentPage) => {
        setBookingList([]);
        setLoading(true);
        try {
                const payload = {
                    working_delivery_from_date:"",
                    type: ["loan"],
                    status: ["pending", "booked", "dispatch", "return","close","prepare","query", "ready_for_dispatch"],
                    operation_from_date: operationDate,
                    operation_to_date: toOperationDate,
                    search: searchTerm != undefined ? searchTerm : search,
                    page: currentPage != undefined ? currentPage : activePage,
                    limit: limit,
                    reps_id:user?.data?._id
                };

            // const res = await repsBookingService.getBookingForDashboard({
            //     working_delivery_from_date:"",
            //     type: ["loan"],
            //     status: ["pending", "booked", "dispatch", "return","close","prepare","query"],
            //     operation_from_date: operationDate,
            //     operation_to_date: toOperationDate,
            //     search: searchTerm != undefined ? searchTerm : search,
            //     page: currentPage != undefined ? currentPage : activePage,
            //     limit: limit,
            //     reps_id:user?.data?._id
            // });
            // const res = await repsBookingService.getBookingForDashboard(payload);
            
            let res;

            // All Bookings
            if (dayActive === "past") {
                res = await repsBookingService.getAllBookingForDashboard(payload);
            }

            // Operations Today
            else if (dayActive === "today") {
                res = await repsBookingService.getOperationTodayBookingForDashboard(payload);
            }

            // Sets Going Out Today
            else if (dayActive === "setsGoingOutToday") {
                payload.sets_going_out_today = true;

                res = await repsBookingService.getSetsGoingOutTodayBookingForDashboard(payload);
            }

            // Missing POs
            else if (dayActive === "missingPOs") {
                payload.missing_po = true;

                res = await repsBookingService.getMissingPOsBookingForDashboard(payload);
            }

            setBookingList(res?.data);
            setTotalItemsCount(res?.total_count);
            setLoading(false);
            setListRefresh(false);
        } catch (error) {
            console.error("Error: ", error);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if(user?.data?.user_role !== "reps") {
            history.push("/");
        }
    }, []);

    useEffect(() => {
        setUser(JSON.parse(localStorage.getItem("user")));
        handlePageStates(activePage, totalItemsCount, limit);
    }, [activePage, totalItemsCount, limit]);

    useEffect(() => {
        getList(filterOperationFromDate,filterOperationToDate);
    }, [activePage,dayActive]);

    useEffect(() => {
        if(listRefresh){
            getList(filterOperationFromDate,filterOperationToDate);
        }
    }, [listRefresh]);

    const handleSearchOperationFromDate = (val) => {
        setActivePage(1);
        setSearchOperationFromDate(val != null ? new Date(val) : "");
        setfilterOperationFromDate(val != null ? moment(val).format("YYYY-MM-DD") : "");
        setListRefresh(true);
    };

    const handleSearchOperationToDate = (val) => {
        setActivePage(1);
        setSearchOperationToDate(val != null ? new Date(val) : "");
        setfilterOperationToDate(val != null ? moment(val).format("YYYY-MM-DD") : "");
        setListRefresh(true);
    };

    const updatePONumber = (ev,item,index) => {
        let newBookingList = [...bookingList];
        newBookingList[index].bookings.po_number=ev.target.value;
        newBookingList[index].bookings.po_check= ev.target.value==""?true:false;
        setBookingList(newBookingList);
        repsBookingService
            .updatePoNumber({
                id: item?.bookings._id,
                po_check: false,
                po_number: ev.target.value,
            })
            .then(res => {
                console.log("res", res);
            })
            .catch(error => {
                console.error("Error:", error);
            });
    };

    const updateMouseLeave = (item,index) => {
        let newBookingList = [...bookingList];
        newBookingList[index].bookings.po_hover=undefined;
        setBookingList(newBookingList);
    };

    const updateMouseEnter = (item,index) => {
        let newBookingList = [...bookingList];
        newBookingList[index].bookings.po_hover=1;
        setBookingList(newBookingList);
    };

    const capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    // const debouncedSearch = debounce((searchTerm) => {
    //     console.log("searchTerm",searchTerm);
    //     // Perform the search or API call with searchTerm
    //     getList(filterOperationFromDate,filterOperationToDate,searchTerm,1);
    // }, 800);

    const debouncedSearch = useMemo(
    () =>
        debounce((searchTerm) => {
             console.log("searchTerm",searchTerm);
            getList(filterOperationFromDate, filterOperationToDate, searchTerm, 1);
        }, 800),
    [filterOperationFromDate, filterOperationToDate]
);

    // if (!user || user?.data?.user_role !== "reps") {
    //     return <Redirect to="/" />;
    // }
    
    const clearFilter = () => {
        setSearchOperationFromDate("");
        setfilterOperationFromDate("");
        setSearchOperationToDate("");
        setfilterOperationToDate("");
        setSearch("");
        setActivePage(1);
        getList("", "","");
    };

    return (
        <div>
            <Navbar activePage="dashboard" />
            <main className="offset">
                <div className="container-fluid">
                    <div className="row pt-4">
                      <div className="col-lg-12">
                            <div className="ground">
                                <div className="row align-items-start">
                                    <div className="col-lg-5 col-md-12">
                                        <div className="sub-menu mb-0 mb-sm-3">
    
                                            <div
                                                className="btn-group"
                                                role="group"
                                                aria-label="Basic example">
                                                      {/* All Bookings */}
                                                <button
                                                    type="button"
                                                    className={
                                                        "btn btn-secondary mr-1 " +
                                                        (dayActive ==
                                                            "past"
                                                            ? "active "
                                                            : loading ? "btn-disabled" : "")
                                                    }
                                                    onClick={() =>
                                                        !loading ? pastBookings() : ""
                                                    }>
                                                    {"All Bookings"}
                                                </button>
                                                {/* Operations Today Tab */}
                                                <button
                                                    type="button"
                                                    className={
                                                        "btn btn-secondary mr-1 " +
                                                        (dayActive ==
                                                            "today"
                                                            ? "active "
                                                            : loading ? "btn-disabled" : "")
                                                    }
                                                    onClick={() =>
                                                        !loading ? toDay() : ""
                                                    }>
                                                    {"Operations Today"}
                                                </button>
                                              

                                                {/* Sets Going Out Today */}
        
                                                <button
                                                    className={
                                                        "btn btn-secondary mr-1 " +
                                                        (dayActive == "setsGoingOutToday"
                                                            ? "active "
                                                            : loading ? "btn-disabled" : "")
                                                    }
                                                    onClick={() =>
                                                        !loading ? setsGoingOutToday() : ""
                                                    }
                                                >
                                                    Sets going out today
                                                </button>

                                            {/* Missing POs */}
                                                <button
                                                    className={
                                                        "btn btn-secondary " +
                                                        (dayActive == "missingPOs"
                                                            ? "active "
                                                            : loading ? "btn-disabled" : "")
                                                    }
                                                    onClick={() =>
                                                        !loading ? missingPOs() : ""
                                                    }
                                                >
                                                    Missing POs
                                                </button>
                                              <button
                                                    type="button"
                                                    style={{display:"none"}}
                                                    className={
                                                        "btn btn-secondary mx-1 " +
                                                        (dayActive ==
                                                            "tomorrow"
                                                            ? "active "
                                                            : loading ? "btn-disabled" : "")
                                                    }
                                                    onClick={() =>
                                                        !loading ? nextDays() : ""
                                                    }>
                                                    {"Tomorrow"}
                                                </button>
                                              
    </div>
</div>
                                    </div>
                                    <div className="col-lg-2 col-sm-6">
                                        <div className="form-search my-3 my-sm-0">
                                            <Input
                                                className="form-control mr-sm-2"
                                                type="text"
                                                placeholder="Search.."
                                                // value={search}
                                                onChange={e =>
                                                    handleSearch(
                                                        e.target.value,
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-sm-6">
                                        <div className={dayActive === "past" || dayActive === "missingPOs" ? "label_adjust lable-field-position" : ""}>
                                            {dayActive === "past" || dayActive === "missingPOs" ?
                                                <label className="small mb-0">
                                                    Operation Date{" "}
                                                </label> : ""
                                            }
                                            {/* <div className="d-flex justify-content-end" style={{gap:"10px"}}> */}  
                                            {/* icon code required */}
                                            {dayActive === "past" || dayActive === "missingPOs" ? 
                                                <div className="row no-gutters mb-2">
                                                    <div className="col-6 px-0">
                                                        <DatePicker
                                                            dateFormat="dd/MM/yyyy"
                                                            showClearButton={false}
                                                            placeholderText="From"
                                                            selected={searchOperationFromDate}
                                                            onChange={(e) =>handleSearchOperationFromDate(e)}
                                                            //onKeyDown={handleclearFromDate}
                                                            className="form-control"
                                                            disabled={!loading ? false : true}
                                                            customInput={
                                                                <MaskedInput
                                                                    pipe={autoCorrectedDatePipe}
                                                                    mask={[
                                                                        /\d/,
                                                                        /\d/,
                                                                        "/",
                                                                        /\d/,
                                                                        /\d/,
                                                                        "/",
                                                                        /\d/,
                                                                        /\d/,
                                                                        /\d/,
                                                                        /\d/,
                                                                    ]}
                                                                    keepCharPositions={true}
                                                                    guide={true}
                                                                    showMask={false}
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                
                                                    <div className="col-6 px-1">
                                                    <span className="small mr-1 btn-clear">
                                                        <a
                                                            style={{
                                                                position: "relative",
                                                                top: "5px",
                                                            }}
                                                            href="javascript:;"
                                                            onClick={() => clearFilter()}
                                                            >
                                                            Clear
                                                        </a>
                                                    </span>

                                                        <DatePicker
                                                            dateFormat="dd/MM/yyyy"
                                                            showClearButton={false}
                                                            placeholderText="To"
                                                            selected={searchOperationToDate}
                                                            onChange={(e) => handleSearchOperationToDate(e)}
                                                            //onKeyDown={handleclearToDate}
                                                            className="form-control"
                                                            disabled={!loading ? false : true}
                                                            customInput={
                                                                <MaskedInput
                                                                    pipe={autoCorrectedDatePipe}
                                                                    mask={[
                                                                        /\d/,
                                                                        /\d/,
                                                                        "/",
                                                                        /\d/,
                                                                        /\d/,
                                                                        "/",
                                                                        /\d/,
                                                                        /\d/,
                                                                        /\d/,
                                                                        /\d/,
                                                                    ]}
                                                                    keepCharPositions={true}
                                                                    guide={true}
                                                                    showMask={false}
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                </div> : ""
                                            }
                                        
                                        </div>
                                    </div>

                                    {/* New Booking Button */}
                                    <div className="col-lg-2 col-sm-6 d-flex justify-content-end align-items-start">
                                        {/* <div className="col-sm-1 text-right"> */}
                                            <Link
                                                className="btn btn-primary add_option"
                                                to="/reps/booking/add"
                                            >
                                                <i className="fa fa-plus"></i> <span>New Booking</span>
                                            </Link>
                                        {/* </div> */}
                                    </div>
                                    </div>

                                
                                <div className="table-scroll mt-4">
                                    <Table className="table">
                                        <thead>
                                            <tr>
                                                <th
                                                    scope="col"
                                                    style={{
                                                        minWidth: "200px",
                                                    }}>
                                                    Booking #
                                                </th>
                                                <th scope="col">
                                                    Hospital Name{" "}
                                                </th>
                                                <th scope="col">
                                                    Surgeon{" "}
                                                </th>
                                                <th scope="col">
                                                    Operation{" "}
                                                </th>
                                                <th scope="col">PO Number</th>
                                                <th
                                                    scope="col"
                                                    className="text-manage">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {bookingList &&
                                                bookingList.map((item,index) => (
                                                    <tr key={item._id}>
                                                        <td
                                                            width="200"
                                                            data-th="Booking #"
                                                            className="">
                                                            <Link
                                                                to={
                                                                    "/reps/booking/details/" +
                                                                    item
                                                                        .bookings
                                                                        ._id
                                                                }>
                                                                <span>
                                                                    <strong>
                                                                        {" "}
                                                                        {
                                                                            item
                                                                                .bookings
                                                                                .booking_id
                                                                        }{" "}
                                                                    </strong>
                                                                </span>
                                                            </Link>
                                                        </td>
                                                        <td className="" data-th="Hospital Name">
                                                                {
                                                                    item
                                                                        .hospitalId
                                                                        .name
                                                                }
                                                        </td>
                                                        <td data-th="Surgeon" className="">
                                                            {item.bookingSurgeonData && item.bookingSurgeonData.map((surgeon, ind) => (
                                                                <React.Fragment key={ind}>
                                                                    <div><span>{surgeon.SurgeonDetail[0].first_name + " " + surgeon.SurgeonDetail[0].last_name} </span></div>
                                                                </React.Fragment>
                                                            ))}
                                                    </td>
                                                    <td data-th="Operation" className="">
                                                        <div>
                                                            {item.bookings.operation_name}
                                                        </div>
                                                    </td>
                                                    
                                                    <td data-th="" className="">                                                       
                                                        <div className="d-flex po-mobileview"  onMouseEnter={() => updateMouseEnter(item,index)} onMouseLeave={() => updateMouseLeave(item,index)}>
                                                            {item.bookings.po_hover !=undefined ?
                                                                <span className="d-flex">
                                                                    <span style={{width:"100px"}}>PO Number:</span> <input type="text" style={{maxWidth:"110px",marginTop:"-4px"}}  className="text-center ml-2" onChange={e =>updatePONumber(e,item,index)} value={item.bookings.po_number} />
                                                                </span>
                                                                :
                                                                <span className="d-flex">
                                                                    <span style={{width:"100px"}}>PO Number:</span> <input type="text" style={{maxWidth:"110px",marginTop:"-4px"}} className="bg-hide text-center ml-2"  onChange={e =>updatePONumber(e,item,index)} value={item.bookings.po_number==""?"TBC":item.bookings.po_number} />
                                                                </span>
                                                            }
                                                        </div>
                                                    </td>

                                                    <td className="text-manage">
                                                        <div className="action-area dropdown">
                                                            <div className="mb-2">
                                                                <span
                                                                    className={
                                                                    "capsule " +
                                                                    (item.bookings.status == "booked" && dateFormat(item.bookings.working_delivery_date,"yyyy-mm-dd") != dateFormat(new Date(),"yyyy-mm-dd") 
                                                                    || item.bookings.status === "close" 
                                                                    || item.bookingcollections.length && item.bookingreturns.length === 0
                                                                    || item.bookings.status == "dispatch" && item.bookingcollections.length === 0 && item.bookingreturns.length === 0
                                                                        ? "green-dim "
                                                                        : "red-dim ") +
                                                                    " mr-2 mb-1"
                                                                }>
                                                                    {item
                                                                        .bookings
                                                                        .status ==
                                                                        "dispatch" && (
                                                                        <div>
                                                                            {item.bookingcollections.length && item.bookingreturns.length === 0 ? "Collected" : item.bookingreturns.length > 0 ? "Attempting Return (Partial)" : "Dispatched"}
                                                                        </div>
                                                                    )}
                                                                    {item
                                                                        .bookings
                                                                        .status !=
                                                                        "dispatch" &&
                                                                        capitalize(
                                                                            item.bookings.status === "booked" && dateFormat(item.bookings.working_delivery_date,"yyyy-mm-dd") === dateFormat(new Date(),"yyyy-mm-dd") ? "Pending Dispatch" : item.bookings.status === "booked" ? 
                                                                            "Booked and Confirmed" : 
                                                                            item.bookings.status === "ready_for_dispatch" ? "Ready for Dispatch" : 
                                                                            item.bookings.status === "pending" ? "Booked and not confirmed" : 
                                                                            item.bookings.status === "close" ? "Fully Return" : item.bookings.status
                                                                        )}
                                                                </span>
                                                            </div>
                                                            
                                                            <div className="mb-2">
                                                                {(item.bookings
                                                                    .status ===
                                                                    "pending" ||
                                                                    item.bookings
                                                                        .status ===
                                                                        "booked" || item.bookings
                                                                        .status ===
                                                                        "ready_for_dispatch") && (
                                                                    <span>
                                                                        <Link
                                                                            className="btn btn-sm1 btn-outline-primary"
                                                                            to={
                                                                                "/reps/booking/edit/" +
                                                                                item.bookings
                                                                                    ._id
                                                                            }
                                                                        >
                                                                            Edit
                                                                        </Link>
                                                                    </span>
                                                                )}
                                                                </div>
                                                                <div className="mb-2">
                                                                <span>
                                                                    <Link
                                                                        className="btn btn-outline-primary btn-sm1"
                                                                        to={
                                                                            "/reps/booking/details/" +
                                                                            item
                                                                                .bookings
                                                                                ._id
                                                                        }>
                                                                        More Details 
                                                                    </Link>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    </tr>
                                                ))}

                                            {bookingList && bookingList.length == 0 && loading == true &&  
                                                <tr className="text-center">
                                                    <td colSpan="6">
                                                        <div className="loading-state-new">
                                                            <div className="loading"></div>
                                                        </div>                                               
                                                    </td>
                                                </tr>                                                  
                                               
                                            }

                                            {bookingList &&
                                                bookingList.length == 0 &&
                                                loading == false && (
                                                    <tr className="text-center">
                                                        <td colSpan="6">
                                                            No Record Found
                                                        </td>
                                                    </tr>
                                                )}
                                        </tbody>
                                    </Table>
                                </div>
                            </div>

                            {bookingList && bookingList.length > 0 && (
                                <div>
                                    <Pagination
                                        activePage={activePage}
                                        itemsCountPerPage={limit}
                                        totalItemsCount={
                                            totalItemsCount
                                        }
                                        pageRangeDisplayed={5}
                                        onChange={handlePageChange.bind(
                                            this,
                                        )}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                        innerClass="pagination justify-content-center mb-5"
                                        activeLinkClass="active"
                                        nextPageText="Next"
                                        prevPageText="Prev"
                                    />
                                    <br className="d-block d-sm-none" /><br className="d-block d-sm-none" />
                                </div>
                            )}

                            {/* Dispatch Details Modal */}
                        </div>
                    </div>
                    {/*<!--/row-->*/}
                </div>
            </main>

            <Footer />
        </div>
    );
};
export default RepsDashboard;

